import React from 'react';
import styled from 'styled-components';
import { superRedA11y } from '@engage/colors/base';
import { useReduxState } from '@engage/redux/hooks';
import { getOwnSubscriptions, getActiveSubs } from '@engage/subscriptions/selectors';
import { label12 } from '@engage/typography/font-styles';
import { track } from '@members/analytics/api';
import { button1Styles, smallButtonStyles } from '@members/buttons/buttons';
import { Tiering } from '@members/copy/models.generated/Tiering';
import { UpsellIcon } from '@members/icons/Upsell';
import { useIsEligibleForFreeTrial } from '@members/tiering/hooks/useIsEligibleForFreeTrial';
import { useUpgradeOrReactivate } from '@members/tiering/hooks/useUpgradeOrReactivate';
import { trackTappedHomescreenTopNavigation } from '../analytics';

const TRACKING_PARAMS = {
  source: 'Upgrade Tab',
};

const UpsellCTA = () => {
  const subs = useReduxState(getOwnSubscriptions);
  const hasActiveSub = Boolean(getActiveSubs(subs).length);
  const hasSubsNoActiveSub = subs && subs.length > 0 && !hasActiveSub;

  const isEligibleForFreeTrial = useIsEligibleForFreeTrial();
  const upgradePath = useUpgradeOrReactivate(TRACKING_PARAMS);
  const upsellText = hasSubsNoActiveSub ? Tiering.Reactivate : Tiering.Upgrade;

  const onClick = () => {
    if (isEligibleForFreeTrial) {
      track(trackTappedHomescreenTopNavigation('30 Day Trial', 'Navigation'));
    } else {
      track(trackTappedHomescreenTopNavigation('Upgrade', 'Navigation'));
    }
  };
  return (
    <UpsellLink data-test-id="trialUpgradeButton" href={upgradePath} onClick={onClick}>
      <UpsellIcon />
      <UpsellText>{upsellText}</UpsellText>
    </UpsellLink>
  );
};

const UpsellLink = styled.a`
  ${button1Styles}
  ${smallButtonStyles}
  display: flex;
  justify-content: center;
  align-items: center;
  width: fit-content;
  gap: 5px;
  background-color: ${superRedA11y};
`;

const UpsellText = styled.p`
  ${label12};
  white-space: nowrap;
  font-weight: 500;
`;

export { UpsellCTA };
